import _ from "lodash";

export default {
  mounted(el, binding) {
    //this line ist needed for getting focus on the element
    el.setAttribute("tabindex", 0);
    if (!binding.modifiers.multiple) {
      const modifiers = binding.modifiers;
      el.handleShortcut = function (event) {
        if (!!modifiers.ctrl == event.ctrlKey && !!modifiers.shift == event.shiftKey && !!modifiers.meta == event.metaKey && !!modifiers.alt == event.altKey) {
          if (modifiers[_.toLower(event.key)]) {
            if (modifiers.prevent) event.preventDefault();
            event.target.focus();
            binding.value();
          }
        }
        if (!modifiers.ctrl && !event.ctrlKey && !modifiers.shiftK && !event.shiftKey && !modifiers.meta && !event.metaKey && !modifiers.alt && !event.altKey) {
          if (modifiers[_.toLower(event.key)]) {
            if (modifiers.prevent) event.preventDefault();
            event.target.focus();
            binding.value();
          }
        }
      };

      el.addEventListener("keydown", el.handleShortcut);
    } else {
      if (Array.isArray(binding.value)) {
        el.handleShortcut = [];
        binding.value.forEach((shortcut) => {
          const handleshortcut = function (event) {
            if (
              !!shortcut.ctrlKey == event.ctrlKey &&
              !!shortcut.shiftKey == event.shiftKey &&
              !!shortcut.metaKey == event.metaKey &&
              !!shortcut.altKey == event.altKey
            ) {
              if (_.toLower(shortcut.key) == _.toLower(event.key)) {
                if (binding.modifiers.prevent) event.preventDefault();
                event.target.focus();
                shortcut.callback();
              }
            }
          };
          el.handleShortcut.push(handleshortcut);
          el.addEventListener("keydown", handleshortcut);
        });
      } else {
        console.error("Please provide an Array for Multiple-Shortcut-Directive!");
      }
    }
  },
  unmounted(el, binding) {
    if (binding.modifiers.multiple) {
      el.handleShortcut.forEach((x) => {
        el.removeEventListener("keydown", x);
      });
    } else {
      el.removeEventListener("keydown", el.handleShortcut);
    }
  }
};
